import { FC } from 'react';
import moment from 'moment';
import { ReactComponent as WarningPendingIcon } from 'assets/icons/warning_pending_icon.svg';

interface RebookingWarningMessageProps {
  appointment: any;
}

const RebookingWarningMessage: FC<RebookingWarningMessageProps> = ({
  appointment,
}) => {
  const pmsName = appointment.pmsPatient
    ? `${appointment.pmsPatient.firstName} ${appointment.pmsPatient.lastName}`
    : '';

  const doctorName =
    appointment.doctor?.name || appointment.practitioner?.name || '';

  const appointmentDate = appointment.appointmentDate
    ? moment(appointment.appointmentDate, 'YYYY-MM-DD').format('MMM DD, YYYY')
    : '';

  let startTime = appointment.startTime || '';
  if (appointment.linkedAppointment?.startTime) {
    const childTime = moment(appointment.startTime, 'HH:mm:ss');
    const linkedTime = moment(
      appointment.linkedAppointment.startTime,
      'HH:mm:ss'
    );
    startTime = childTime.isBefore(linkedTime)
      ? appointment.startTime
      : appointment.linkedAppointment.startTime;
  }
  const formattedStartTime = startTime
    ? moment(startTime, 'HH:mm:ss').format('hh:mm A')
    : '';

  return (
    <div className="min-h-[48px] bg-[#FFF9EE] border border-[#F1A80933] rounded-[1rem] px-1.2 py-0.2 text-12 text-darkest-grey flex items-center gap-x-0.8">
      <WarningPendingIcon className="w-1.4 h-1.4 shrink-0 all-child:!fill-[#F1A809]" />
      <span>
        {pmsName} has an existing appointment in the practice management system{' '}
        {appointmentDate}, {formattedStartTime} with {doctorName} - may need to
        be cancelled.
      </span>
    </div>
  );
};

export default RebookingWarningMessage;
